export default function Menu() {
	// Find all menu items which have children
	const menuItems = document.querySelectorAll('.menu-item-has-children > a');

	// Add event listener to each menu item
	menuItems.forEach(menuItem => {
		menuItem.addEventListener('click', (ev) => {
			ev.preventDefault();
			// Add the 'menu-active' class to the menu item
			menuItem.closest('.menu-item-has-children').classList.toggle('menu-active');
		});
	});
}
